<svg class="progress-circle" width="24" height="24" viewBox="0 0 48 48">
  <circle class="progress-circle-track" cx="24" cy="24" r="20" fill="none" stroke="#ffffff00" stroke-width="2" />
  <circle
    class="progress-circle-stroke"
    cx="24"
    cy="24"
    r="20"
    fill="none"
    stroke="#ffffff"
    stroke-width="2"
    [attr.stroke-dasharray]="circumference"
    [attr.stroke-dashoffset]="strokeDashoffset()"
    transform="rotate(270 24 24)"
    stroke-linecap="round"
  />
  <text
    x="24"
    y="26"
    text-anchor="middle"
    dominant-baseline="central"
    font-size="20"
    font-weight="500"
    fill="currentColor"
  >
    {{ seconds() }}
  </text>
</svg>
